import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidatesNotices, getCandidatesNoticesStat } from '../../../../actions/settings/candidates'
import styles from './styles.module.scss'
import { Checkbox, Input, Textarea } from '../../../../components/ModalInputs'
import { SettingsContext } from '../../../../utils/context'


const Notices = () => {

  const dispatch = useDispatch()
  const { noticeSettingsForm } = useContext(SettingsContext)

  useEffect(() => {
    dispatch(getCandidatesNotices())
    dispatch(getCandidatesNoticesStat())
  }, [])


  const { values, handleChange, setFieldValue } = noticeSettingsForm

  const { candidates } = useSelector(state => state.settings)
  const { notices, notices_stat } = candidates

  const setCheckboxValue = () => {
    const newValue = values.ApplicantSMTPUseTLS === '1' ? '0' : '1'
    setFieldValue('ApplicantSMTPUseTLS', newValue)
  }

  return (
    <div>
      <div className={styles.paramsChildBLock}>

        <p>Электронная рассылка</p>

        <Input
          label='Почтовый адрес'
          name='ApplicantMail'
          style={{ width: '100%' }}
          value={values.ApplicantMail}
          onChange={handleChange}
        />

        <div className={styles.inputsRow}>
          <Input
            label='Сервер'
            name='ApplicantSMTPHost'
            value={values.ApplicantSMTPHost}
            onChange={handleChange}
          />

          <Input
            label='Порт'
            name='ApplicantSMTPPort'
            value={values.ApplicantSMTPPort}
            onChange={handleChange}
          />

          <Checkbox
            label='Использовать TLS'
            checked={parseInt(values.ApplicantSMTPUseTLS)}
            onChange={setCheckboxValue}
          />
        </div>

        <div className={styles.inputsRow}>
          <Input
            label='Имя пользователя'
            name='ApplicantSMTPUser'
            value={values.ApplicantSMTPUser}
            onChange={handleChange}
          />

          <Input
            label='Пароль'
            name='ApplicantSMTPPassword'
            type='password'
            value={values.ApplicantSMTPPassword}
            onChange={handleChange}
          />
        </div>

        <Textarea
          label='Текст уведомления о приеме заявки'
          name='ApplicantConfirmText'
          className={styles.noticeTextarea}
          value={values.ApplicantConfirmText}
          onChange={handleChange}
        />

      </div>

      {notices?.DontReplyText && (
        <div className={styles.noticePreview}>
          <div
            className={styles.noticePreviewContent}
            dangerouslySetInnerHTML={{ __html: notices.DontReplyText }}
          />
        </div>
      )}

      {notices_stat && (
        <div className={styles.noticeStats}>
          <div className={styles.statItem}>
            <span className={styles.statLabel}>Всего записей:</span>
            <span className={styles.statValueBlack}>{notices_stat.cnt_all || 0}</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statLabel}>Отправлено извещений:</span>
            <span className={styles.statValueGreen}>{notices_stat.cnt_sent || 0}</span>
          </div>
          <div className={styles.statItem}>
            <span className={styles.statLabel}>Не отправлено извещений:</span>
            <span className={styles.statValueBlue}>{notices_stat.cnt_unsent || 0}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default Notices